import { render, staticRenderFns } from "./Icon-svg.vue?vue&type=template&id=21e506ba&"
import script from "./Icon-svg.vue?vue&type=script&lang=js&"
export * from "./Icon-svg.vue?vue&type=script&lang=js&"
import style0 from "./Icon-svg.vue?vue&type=style&index=0&id=21e506ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports